import axios from 'axios'

// This function fetches product pictures from the server for the service worker to cache them
export const fetchProductPictures = async (pictureURLs: string[]) => {
    const uniqueURLs = Array.from(new Set(pictureURLs))

    uniqueURLs.forEach((url) => {
        if (typeof url === 'string' && /\.(png|jpg|jpeg|svg)$/i.test(url)) {
            axios.get(url).catch((error) => {
                if (error.response?.status === 404) {
                    console.warn(`Image not found: ${url}`)
                } else {
                    console.error(`Error fetching image ${url}:`, error)
                }
            })
        }
    })
}
